<template>
<v-autocomplete
  v-model="object"
  :label="itemAction.name"
  :item-text="itemText"
  :items="objects"
  :search-input.sync="findObject"
  :item-value=" (itemAction.itemValue)? itemAction.itemValue : 'id'"
  no-data-text="Sin Resultados"
  clearable
  outlined
  dense>
  <!-- :item-text="itemText" -->
    <template v-slot:selection="{ item }">
        <v-list-item-action-text dense>
          {{ itemText(item) }}
        </v-list-item-action-text>
    </template>

    <template v-slot:item="{ item }">
        <v-list-item-action-text dense>
          {{ itemText(item) }}
        </v-list-item-action-text>
    </template>
</v-autocomplete>

</template>
<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
export default {
  name: 'SearchEmployee',
  props: ['itemAction', 'onSuccess', 'Selected', 'clear', 'setterModel'],
  data: () => ({
    object: null,
    objects: [],
    findObject: null
  }),
  mounted () {},
  methods: {
    itemText (item) {
      if (item && this.itemAction.nameid === 'empleado_id') {
        return `${item.cve_empleado} ${item.nombres} ${item.apellidos}`
      } else if (item && this.itemAction.nameid === 'solicitante_id') {
        return `${item.cve_empleado} ${item.nombres} ${item.apellidos}`
      } else if (item && this.itemAction.nameid === 'inventario_id') {
        return `${item.FamiliaNombre} - ${item.NombreEquipo}`
      } else if (item && this.itemAction.nameid === 'insumo_id') {
        return `${JSON.parse(item.descripcion).nombre} - ${item.cantidad}`
      } else if (item && this.itemAction.nameid === 'departamento_id') {
        return `${item.nombre}`
      }

      return 'No Title'
    },
    getDinamicData (name) {
      const token = this.$cookies.get('token')
      axios.get(`${this.itemAction.url}/${name}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        this.objects = []
        this.objects.push(...response.data)
      }).catch(error => {
        if (error == null) {}
      })
    },
    ...mapMutations(['SET_DATA_OBJECT_FIND'])
  },
  computed: {
  },
  watch: {
    clear (val) {
      this.object = null
      this.objects = []
    },
    findObject (val) {
      if (val == null || val === '') return
      this.getDinamicData(val.replace(' ', '_'))
    },
    object (val) {
      let object = null
      this.objects.map(item => {
        if (item[this.itemAction.itemValue] === val) {
          object = item
        }
      })
      this.onSuccess({ id: this.itemAction.nameid, data: val, objectnameid: this.itemAction.objecName, objectdata: object })
      if (this.Selected) { this.Selected(this.itemAction) }
    },
    setterModel (val) {
      if (val) {
        this.object = val.id
        this.objects.push(val)
      }
    }
  }
}
</script>

<style>

</style>
